import { applyExpansions } from '../core/expansion';
import type { SimState } from '../core/state';
import { MATERIALS } from './materials';
import type { MaterialId } from './materials';
import { STAGE1_EXPANSIONS, createStage1State } from './stage1-layout';

export const DEBUG_CASH = 999_999_999;

/** Above every `production` gate in the game by a margin no future tuning pass is likely to cross. */
const DEBUG_SALE_COUNT = 9999;

/**
 * A fully-progressed save rather than a set of bypass flags. Every unlock gate — toolbar buttons and
 * world expansions alike — reads from exactly three places: peak cash, the {@link GateFlags}, and
 * per-material sale counts. Saturating those three is what opens all of it at once, and it keeps the
 * gating code itself free of any `if (debug)` branch that could drift from the real progression.
 */
export function createDebugState(): SimState {
  const state = createStage1State();
  state.economy = {
    cash: DEBUG_CASH,
    research: 0,
    peakCash: DEBUG_CASH,
    saleCount: DEBUG_SALE_COUNT,
    materialSaleCounts: Object.fromEntries(
      Object.keys(MATERIALS).map((material) => [material, DEBUG_SALE_COUNT]),
    ) as Record<MaterialId, number>,
  };
  state.flags = {
    everPlacedFilter: true,
    everPlacedTake: true,
    everPlacedFrom: true,
    everPlacedInterval: true,
    everPlacedSubject: true,
  };
  applyExpansions(state, STAGE1_EXPANSIONS);
  return state;
}
